import React from 'react';
import { DataProvider, Urls } from '../Data';
import { TeachingRoot } from './Root';
import { HashSelect } from './HashSelect';


type ConfigProps = {
  urls: Urls
  sidecolumn: HTMLElement | null
  breadcrumb: HTMLElement | null
  lang: string
}

export function TeachingConfig({ urls, sidecolumn, breadcrumb, lang }: ConfigProps) {
  const _lang = lang === 'de' ? 'de' : 'en';
  return (
    <DataProvider urls={urls} lang={_lang} needs={['semesters', 'users']}>
      <HashSelect />
      <TeachingRoot sidecolumn={sidecolumn} breadcrumb={breadcrumb} />
    </DataProvider>
  );
}
